var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBatchsendActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.426 5.5c.033 0 .07.008.107.012A1.85 1.85 0 0 1 5.75 5.5h13.125c1.448 0 2.625 1.191 2.625 2.666v10.668c0 1.47-1.177 2.666-2.625 2.666H3.125C1.673 21.5.5 20.304.5 18.834v-.296c0-.366.295-.666.656-.666a.66.66 0 0 1 .657.625l.006.152a1.65 1.65 0 0 0 1.503 1.501.669.669 0 0 0 .131.013h15.098c.906 0 1.64-.746 1.64-1.666V8.499c0-.92-.734-1.666-1.64-1.666H5.426a.99.99 0 0 0-.984 1v7.664a.663.663 0 0 1-.657.667c-.36 0-.656-.3-.656-.667V8.166c0-.075.004-.15.012-.225-.004-.037-.012-.07-.012-.108v-.334c0-1.103.882-1.999 1.969-1.999zM4 17.5c.275 0 .5.225.5.5s-.225.5-.5.5a.501.501 0 0 1-.5-.5c0-.275.225-.5.5-.5z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.143 17.5c.353 0 .642-.303.642-.673V6.223c0-.93.68-1.683 1.286-1.683.124 0 .269-.013.422-.072.273-.105.45-.311.586-.572l.72-1.401c.196-.38.694-.648 1.144-.648h3.242c.446 0 .952.269 1.149.648l.73 1.397c.141.265.398.48.675.576.113.042.241.067.334.067h5.784c.354 0 .643-.303.643-.673 0-.37-.29-.673-.643-.673h-5.56l-.947-1.721C11.036.904 10.237.5 9.53.5H5.674c-.711 0-1.507.404-1.816.972l-.936 1.725C1.572 3.281.5 4.451.5 5.887v10.94c0 .37.29.673.643.673z",
    fill: "#00E1D4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBatchsendActive);
export default __webpack_public_path__ + "static/media/icon-batchsend-active.e0b32dfe0384d1d4f70668d18277a644.svg";
export { ForwardRef as ReactComponent };